// extracted by mini-css-extract-plugin
export default {"main":"Main_main__CYs7Q","content":"Main_content__zlK7L","title":"Main_title__VyeZg","desc":"Main_desc__3cuD8","control":"Main_control__ktTdI"};